export const selectLearningCategories = (state) => {
    return state.learningCategories.models;
};
export const selectLearningCategory = (id) => (state) => {
    return state.learningCategories.models.filter((c) => c.id === id)[0];
};
export const selectAreLearningCategoriesLoading = (state) => {
    if (!state.learningCategories)
        return true;
    return state.learningCategories.isLoading;
};
